<!-- 页面内容 -->

<template>
  <div class='content' style="width: 100%;position: relative;">
    <img class="kf" @click="kf" src="@/assets/images2/32.png" alt="">
    <img class="car" @click="goCar" src="@/assets/images2/33.png" alt="">
    <img class="topV" @click="topM" src="@/assets/images2/34.png" alt="">
    <div>
      <!-- banner第一行   muted="muted"-->
      <el-carousel :height="imgHeight0" v-if="banner1Type == 0" :show-arrow="true" indicator-position="none"
        arrow="hover">
        <el-carousel-item v-for="(item, index) in banner1" :key="index">
          <div style="height: 846px;">
            <a v-if="bannerUrl1.length > 0" :href="bannerUrl1[index]" target="_blank"
              style="display: block;width: 100%;height: 100%;">
              <img ref="imgH0" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </a>
            <img ref="imgH0" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
          </div>
        </el-carousel-item>
      </el-carousel>
      <div v-else class="top_gg" style="height: 846px;" @click="openWebUrl(banner1Video)">
        <video :src="banner1" autoplay loop muted="muted"></video>
      </div>

      <!-- banner第二行 -->
      <el-carousel :height="imgHeight" v-if="banner2Type == 0" :show-arrow="true" indicator-position="none"
        arrow="hover">
        <el-carousel-item v-for="(item, index) in banner2" :key="index">
          <div>
            <a v-if="bannerUrl2.length > 0" :href="bannerUrl2[index]" target="_blank"
              style="display: block;width: 100%;height: 100%;">
              <img ref="imgH" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </a>
            <img ref="imgH" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
          </div>
        </el-carousel-item>
      </el-carousel>
      <div v-else class="top_gg" @click="openWebUrl(banner2Video)">
        <video :src="banner2" autoplay loop muted="muted"></video>
      </div>

      <!-- 横幅1 -->
      <el-carousel :height="imgHeight2" v-if="banner3Type == 0" :show-arrow="false" indicator-position="none"
        arrow="hover">
        <el-carousel-item v-for="(item, index) in banner3" :key="index">
          <div>
            <a v-if="bannerUrl3" :href="bannerUrl3" target="_blank" style="display: block;width: 100%;height: 100%;">
              <img ref="imgH2" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </a>
            <img ref="imgH2" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
          </div>
        </el-carousel-item>
      </el-carousel>
      <div v-else class="top_gg" @click="openWebUrl(banner3Video)">
        <video :src="banner3" autoplay loop muted="muted"></video>
      </div>

      <!-- banner第三行 -->
      <el-carousel :height="imgHeight3" v-if="banner4Type == 0" :show-arrow="false" indicator-position="none"
        arrow="hover">
        <el-carousel-item v-for="(item, index) in banner4" :key="index">
          <div>
            <a v-if="bannerUrl4" :href="bannerUrl4" target="_blank" style="display: block;width: 100%;height: 100%;">
              <img ref="imgH3" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </a>
            <img ref="imgH3" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
          </div>
        </el-carousel-item>
      </el-carousel>
      <div v-else class="top_gg" @click="openWebUrl(banner4Video)">
        <video :src="banner4" autoplay loop muted="muted"></video>
      </div>

      <!-- banner第四行  一行两个-->
      <div class="top_gg">
        <el-carousel class="top_gg_one" :height="imgHeight4" v-if="banner5Type == 0" :show-arrow="false"
          indicator-position="none" arrow="hover">
          <el-carousel-item v-for="(item, index) in banner5" :key="index">
            <div>
              <a v-if="bannerUrl5" :href="bannerUrl5" target="_blank" style="display: block;width: 100%;height: 100%;">
                <img ref="imgH4" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
              </a>
              <img ref="imgH4" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </div>
          </el-carousel-item>
        </el-carousel>
        <div v-else class="top_gg_one" @click="openWebUrl(banner5Video)">
          <video :src="banner5" autoplay loop muted="muted"></video>
        </div>
        <el-carousel class="top_gg_one" :height="imgHeight4" v-if="banner6Type == 0" :show-arrow="false"
          indicator-position="none" arrow="hover">
          <el-carousel-item v-for="(item, index) in banner6" :key="index">
            <div>
              <a v-if="bannerUrl6" :href="bannerUrl6" target="_blank" style="display: block;width: 100%;height: 100%;">
                <img ref="imgH4" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
              </a>
              <img ref="imgH4" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </div>
          </el-carousel-item>
        </el-carousel>
        <div v-else class="top_gg_one" @click="openWebUrl(banner6Video)">
          <video :src="banner6" autoplay loop muted="muted"></video>
        </div>
      </div>
      <!-- banner第五行  一行三个-->
      <div class="top_gg">
        <!-- <div v-if="banner7Type == 0" class="top_gg_one">
          <a v-if="bannerUrl7" :href="bannerUrl7" target="_blank" style="display: block;height: 100%;">
            <img class="banner_item_box" :src="banner7" alt="" />
          </a>
          <img v-else class="banner_item_box" :src="banner7" alt="" />
        </div> -->
        <el-carousel class="top_gg_one" :height="imgHeight5" v-if="banner7Type == 0" :show-arrow="false"
          indicator-position="none" arrow="hover">
          <el-carousel-item v-for="(item, index) in banner7" :key="index">
            <div>
              <a v-if="bannerUrl7" :href="bannerUrl7" target="_blank" style="display: block;width: 100%;height: 100%;">
                <img ref="imgH5" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
              </a>
              <img ref="imgH5" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </div>
          </el-carousel-item>
        </el-carousel>
        <div v-else class="top_gg_one" @click="openWebUrl(banner7Video)">
          <video :src="banner7" autoplay loop muted="muted"></video>
        </div>

        <!-- <div v-if="banner8Type == 0" class="top_gg_two">
          <a v-if="bannerUrl8" :href="bannerUrl8" target="_blank" style="display: block;height: 100%;">
            <img class="banner_item_box" :src="banner8" alt="" />
          </a>
          <img v-else class="banner_item_box" :src="banner8" alt="" />
        </div> -->
        <el-carousel class="top_gg_one" :height="imgHeight5" v-if="banner8Type == 0" :show-arrow="false"
          indicator-position="none" arrow="hover">
          <el-carousel-item v-for="(item, index) in banner8" :key="index">
            <div>
              <a v-if="bannerUrl8" :href="bannerUrl8" target="_blank" style="display: block;width: 100%;height: 100%;">
                <img ref="imgH5" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
              </a>
              <img ref="imgH5" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </div>
          </el-carousel-item>
        </el-carousel>
        <div v-else class="top_gg_one" @click="openWebUrl(banner8Video)">
          <video :src="banner8" autoplay loop muted="muted"></video>
        </div>

        <!-- <div v-if="banner9Type == 0" class="top_gg_two">
          <a v-if="bannerUrl9" :href="bannerUrl9" target="_blank" style="display: block;height: 100%;">
            <img class="banner_item_box" :src="banner9" alt="" />
          </a>
          <img v-else class="banner_item_box" :src="banner9" alt="" />
        </div> -->
        <el-carousel class="top_gg_one" :height="imgHeight5" v-if="banner9Type == 0" :show-arrow="false"
          indicator-position="none" arrow="hover">
          <el-carousel-item v-for="(item, index) in banner9" :key="index">
            <div>
              <a v-if="bannerUrl9" :href="bannerUrl9" target="_blank" style="display: block;width: 100%;height: 100%;">
                <img ref="imgH5" style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
              </a>
              <img ref="imgH5" v-else style="width: 100%;height: 100%;" :src="item" alt="" @load="imgLoad">
            </div>
          </el-carousel-item>
        </el-carousel>
        <div v-else class="top_gg_one" @click="openWebUrl(banner9Video)">
          <video :src="banner9" autoplay loop muted="muted"></video>
        </div>
      </div>

    </div>

    <el-carousel :height="imgHeight6" class="hengfu_box" :show-arrow="false" indicator-position="none" arrow="hover">
      <el-carousel-item v-for="item in hengfu1List" :key="item.bannerId">
        <div class="top_gg">
          <a v-if="item.url" :href="item.url" target="_blank" style="display: block;width: 100%;height: 100%;">
            <img ref="imgH6" style="width: 100%;height: 100%;" :src="item.image" alt="">
          </a>
          <img ref="imgH6" v-else style="width: 100%;height: 100%;" :src="item.image" alt="">
        </div>
      </el-carousel-item>
    </el-carousel>

    <div>
      <!-- <el-carousel height="660px">
        <el-carousel-item v-for="item in bannerList" :key="item.bannerId">
          <div class="banner_item_box" style="height: 220px;">
            <img :src="item.image">
          </div>
          <div style="display: flex;">
            <div class="banner_item_box" style="height: 220px;">
              <img :src="item.image">
            </div>
            <div class="banner_item_box" style="height: 220px;">
              <img :src="item.image">
            </div>
          </div>
          <div style="display: flex;">
            <div class="banner_item_box" style="height: 220px;">
              <img :src="item.image">
            </div>
            <div class="banner_item_box" style="height: 220px;">
              <img :src="item.image">
            </div>
            <div class="banner_item_box" style="height: 220px;">
              <img :src="item.image">
            </div>
          </div>
        </el-carousel-item>
      </el-carousel> -->
    </div>

    <!-- <el-carousel height="152px" class="hengfu_box">
      <el-carousel-item v-for="item in hengfu1List" :key="item.bannerId">
        <div class="top_gg" style="width: 100%;">
          <a v-if="item.url" :href="item.url" target="_blank" style="display: block">
            <img :src="item.image" alt="">
          </a>
          <img v-else :src="item.image" alt="">
        </div>
      </el-carousel-item>
    </el-carousel> -->

    <!-- <div class="min_title_box" style="padding-left: 32px;padding-right: 32px;">
      <div class="mtt">New arrivals</div>
      <router-link to="/home/goodList?openType=1" class="all">View all
      </router-link>
    </div> -->
    <div class="arrivals-page">
      <div class="left-page">
        <div class="left-page-item1"></div>
        <div class="left-page-item2"></div>
        <div class="left-page-item3"></div>
      </div>
      <div class="title">New arrivals</div>
      <div class="left-page">
        <div class="left-page-item3"></div>
        <div class="left-page-item2"></div>
        <div class="left-page-item1"></div>
      </div>
    </div>
    <!-- thumbnailNew -->
    <div class="NewArrivalsList_box" style="padding: 32px 32px;">
      <div class="box_item" v-for="(item, index) in NewArrivalsList" :key="index">
        <img :src="item.thumbnailNew" alt="" class="icon" @click="toGoodDetail(item, 0)">
      </div>
      <!-- <div class="left_box">
        <div v-if="newGoodOne.goodsId" class="it_box it4" @click="toGoodDetail(newGoodOne, 0)"
          style="padding-top: 0px;justify-content: center;">
          <img :src="newGoodOne.thumbnail" alt="" class="icon">
        </div>
        <div v-if="newGoodThree.goodsId" class="it_box it3" @click="toGoodDetail(newGoodThree, 0)">
          <img :src="newGoodThree.thumbnail" alt="" class="icon">
        </div>
      </div>
      <div class="right_box">
        <div v-if="newGoodTow.length" class="it_box it2">
          <div v-for="(item, index) in newGoodTow" :key="index" class="it_min_box" style="width: 48%;"
            :class="{ bgg: index }" @click="toGoodDetail(item, 0)">
            <img :src="item.thumbnail" alt="" class="icon">
          </div>
        </div>
        <div v-if="newGoodFour.goodsId" class="it_box it1" @click="toGoodDetail(newGoodFour, 0)">
          <img :src="newGoodFour.thumbnail" alt="" class="icon">
        </div>
      </div> -->
    </div>

    <!-- one cate -->
    <!-- 品牌列表 -->
    <div class="brand-page tow_cate_box">
      <img @click="offsetLeft" src="@/assets/images1/22.png" alt="" class="arrow_left" style="margin-right: 32px;">
      <div class="scroll_box" ref="scroll">
        <div class="it_box" v-for="(item, index) in brandListNews" :key="index" @click="toGoodList(item, index)">
          <img :src="item.logo" alt="" style="object-fit: cover">
        </div>
      </div>
      <img @click="offsetRight" src="@/assets/images1/16.png" alt="" class="arrow_right" style="margin-left: 32px;">
    </div>

    <!-- <div class=" one_cate_box" style="padding-left: 32px;padding-right: 32px;">
      <div class="it" v-for="(item, index) in oneTabData" :key="index" :class="{ cur: item.value == oneActive }"
        @click="oneActive = item.value">{{ item.name }}
      </div>
    </div> -->
    <!-- tow cate -->
    <!-- <div v-if="brandList.length" class=" tow_cate_box" style="padding-left: 32px;padding-right: 32px;">
      <img @click="offsetLeft" src="@/assets/images1/22.png" alt="" class="arrow_left">
      <div class="scroll_box" ref="scroll">
        <div class="it_box" v-for="(item, index) in brandList" :key="index">
          <img :src="item.logo" alt="" style="object-fit: cover" @click="toGoodList(item)">
        </div>
      </div>
      <img @click="offsetRight" src="@/assets/images1/16.png" alt="" class="arrow_right">
    </div> -->


    <!-- line box -->
    <el-carousel height="152px" class="hengfu_box special-hengfu" :show-arrow="false" indicator-position="none"
      arrow="hover">
      <el-carousel-item v-for="item in hengfu2List" :key="item.bannerId">
        <div class="img_line_box">
          <a v-if="item.url" :href="item.url" style="display: block;" target="_blank">
            <img :src="item.image" />
          </a>
          <img v-else :src="item.image" />
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- min title -->
    <!-- <div class=" min_title_box" style="padding-left: 32px;padding-right: 32px;">
      <div class="mtt">Hot Products</div>
      <router-link to="/home/hotList" class="all">View all
      </router-link>
    </div> -->
    <div class="arrivals-page" style="background: linear-gradient(90deg,#e62129 0%, #f7ae0d 100%) !important;">
      <div class="left-page">
        <div class="left-page-item1"></div>
        <div class="left-page-item2"></div>
        <div class="left-page-item3"></div>
      </div>
      <div class="title">Hot Products</div>
      <div class="left-page">
        <div class="left-page-item3"></div>
        <div class="left-page-item2"></div>
        <div class="left-page-item1"></div>
      </div>
    </div>
    <!-- <img src="@/assets/images1/24.png" alt="" class="container" style="display: block;"> -->
    <div>
      <el-carousel height="640px" :show-arrow="false" indicator-position="none" arrow="hover">
        <el-carousel-item v-for="item in HotBannerList" :key="item.bannerId">
          <img :src="item.image" style="width: 100%;height: 100%;" @click="bannerClick(item)">
        </el-carousel-item>
      </el-carousel>
    </div>


    <div class="NewArrivalsList_box" style="padding: 32px 32px;">
      <div class="box_item1" v-for="(item, index) in goodList" :key="index">
        <img :src="item.thumbnailHot" alt="" class="icon" @click="toGoodDetail(item, 0)">
      </div>
    </div>

    <el-empty v-if="!goodListLoading && !goodList.length" description=" "></el-empty>

    <!-- 证书 -->
    <!-- v-if="certificateList.length" -->
    <div class="zhengshu_box">
      <div class="container" style="width: 100%;">
        <img v-for="(item, index) in certificateList" :key="index" :src="item.image" alt="" style="width: 100%;">
      </div>
    </div>

    <!--  选择规格加入购物车  -->
    <SelectSkuAddCar ref="selectSkuAddCar" />




    <el-dialog :visible.sync="dialogVisible" width="40%" :before-close="handleClose" :modal-append-to-body="true"
      :show-close="false" center>
      <div class="pup">
        <img class="topImg" src="@/assets/images2/35.png" alt="">
        <div class="t1">Are you 21 years of age or older?</div>
        <div class="t2">This product contains nicotine, and it is prohibited for use by minors.</div>
        <div class="btnV">
          <div class="btn1" @click="GO">Yes, I am 21 or older</div>
          <div class="btn2" @click="GON">No, l am under 21</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import GoodList from '../../../components/GoodList/GoodList.vue';
// import GoodList from '../../../components/GoodList3/GoodList.vue';

export default {
  components: { GoodList },
  data() {
    return {
      NewArrivalsList: [],
      brandListNews: [], //新增 品牌列表
      dialogVisible: false,
      towScrollLeft: 0,
      oneTabData: [
        { name: "Ordinary brand", value: "0" },
        { name: "Featured brand", value: "1" },
        { name: "Popular brand", value: "2" },
        { name: "New brand", value: "3" },
      ],
      oneActive: "0",
      brandList: [],
      goodListLoading: true,
      goodList: [],
      goodListpage: 1,
      goodList_rows: 10,
      goodListtotal: 0,
      goodListtotalPage: 0,
      certificateList: [],
      bannerList: [], // 顶部轮播
      HotBannerList: [], //热销轮播
      hengfu1List: [],
      hengfu1Def: require("@/assets/images1/8.png"),
      hengfu2List: [], // 横幅2
      newGoodOne: { loading: false }, // 新品1
      newGoodTow: [], // 新品1
      newGoodThree: { loading: false }, // 新品1
      newGoodFour: { loading: false }, // 新品1
      banner1: '',
      bannerUrl1: '',
      banner1Type: 0,  // 0是图片 1是视频
      banner1Video: '',
      banner2: '',
      bannerUrl2: '',
      banner2Type: 0,
      banner2Video: '',

      banner3: '',
      bannerUrl3: '',
      banner3Type: 0,
      banner3Video: '',

      banner4: '',
      bannerUrl4: '',
      banner4Type: 0,
      banner4Video: '',

      banner5: '',
      bannerUrl5: '',
      banner5Type: 0,
      banner5Video: '',

      banner6: '',
      bannerUrl6: '',
      banner6Type: 0,
      banner6Video: '',

      banner7: '',
      bannerUrl7: '',
      banner7Type: 0,
      banner7Video: '',

      banner8: '',
      bannerUrl8: '',
      banner8Type: 0,
      banner8Video: '',

      banner9: '',
      bannerUrl9: '',
      banner9Type: 0,
      banner9Video: '',

      imgHeight0: '0',
      imgHeight: '0',
      imgHeight2: '0',
      imgHeight3: '0',
      imgHeight4: '0',
      imgHeight5: '0',
      imgHeight6: '0'
    }
  },
  watch: {
    oneActive() {
      this.getBrandList()
    }
  },
  created() {
    this.getnewestApi();
  },
  mounted() {
    // console.warn(localStorage.getItem("TWO_ONE_AGE"))
    // 初次进来   判断是不是21岁  
    if (localStorage.getItem("TWO_ONE_AGE") == 'false' || localStorage.getItem("TWO_ONE_AGE") == null) {
      this.dialogVisible = true;
    } else {
      this.dialogVisible = false;
    }
    // 获取底部服务横幅 
    this.$get("system/banner/getHotBanner").then(res => {
      this.HotBannerList = res.data || [];
      // console.warn(res, "res")
    })
    // 获取底部服务横幅
    this.$get("system/banner/getCertificationBanner").then(res => {
      this.certificateList = res.data || [];
    })
    // 获取顶部轮播
    this.$get("system/banner/getTopBanner").then(res => {
      this.bannerList = res.data || [];
    })
    // 获取横幅1
    this.$get("system/banner/getAcrossOne").then(res => {
      this.hengfu1List = res.data || [];
    })
    // 获取横幅2
    this.$get("system/banner/getAcrossTwo").then(res => {
      this.hengfu2List = res.data || [];
    })
    // 新品列表
    this.$get("system/goods/list?type=1&brandId=").then(res => {
      const _list = this.goodListAttrFormat(res.rows || []);
      this.NewArrivalsList = _list.slice(0, 6) || [];
      console.warn(this.NewArrivalsList, "新品")
      // console.warn(_list.slice(0, 6) || [], "_list")
      // this.newGoodOne = _list[0] || {};
      // this.newGoodTow = _list.slice(1, 3) || [];
      // this.newGoodThree = _list[3] || {};
      // this.newGoodFour = _list[4] || {};
    })

    this.getBrandList();
    this.goodListpage = this.$route.query.page || 1;
    this.getgoodList();


  },
  destroyed() {
    window.removeEventListener("resize", this.imgLoad, false);
  },
  methods: {
    openWebUrl(URL) {
      console.warn(URL, "URL")
      window.open(URL)
    },
    imgLoad() {
      this.$nextTick(() => {
        if (this.banner1Type == 0) {
          // this.imgHeight0 = `${this.$refs.imgH0[0].height}px` || ""
          this.imgHeight0 = `${846}px` || ""
        }
        if (this.banner2Type == 0) {
          this.imgHeight = `${this.$refs.imgH[0].height}px` || ""
        }
        if (this.banner3Type == 0) {
          this.imgHeight2 = `${this.$refs.imgH2[0].height}px` || "";
        }
        if (this.banner4Type == 0) {
          this.imgHeight3 = `${this.$refs.imgH3[0].height}px` || "";
        }
        if (this.banner5Type == 0 || this.banner6Type == 0) {
          this.imgHeight4 = `${this.$refs.imgH4[0].height}px` || "";
        }
        if (this.banner7Type == 0 || this.banner8Type == 0 || this.banner9Type == 0) {
          this.imgHeight5 = `${this.$refs.imgH5[0].height}px` || "";
        }
        if (this.hengfu1List.length > 0) {
          this.imgHeight6 = `${this.$refs.imgH6[0].height}px` || "";
        }

        // this.imgHeight5 = `${this.$refs.imgH5[0].height}px` || "";
        // this.imgHeight4 = `${this.$refs.imgH4[0].height}px` || "";
        // this.imgHeight3 = `${this.$refs.imgH3[0].height}px` || "";
        // this.imgHeight2 = `${this.$refs.imgH2[0].height}px` || "";
        // this.imgHeight0 = `${this.$refs.imgH0[0].height}px` || "";
        // this.imgHeight = `${this.$refs.imgH[0].height}px` || "";
        // console.log(this.imgHeight)
      })
    },
    /** banner（新增） */
    async getnewestApi() {
      try {
        this.goodListLoading = true;
        var res = await this.$get('system/newest/list');
        let dataList = res.rows;
        console.warn(dataList, "banner新增")
        // let banner1 = "";  //单图banner 第一行
        // let banner2 = "";  //单图banner 第二行
        // "type": "0", //类型（0-banner1、1-banner2、2-banner横图）
        // "flag": "0", //位置（0-第一行、1-第二行、2-第三行）
        if (res.rows.length > 0) {
          dataList.forEach(v => {
            // console.warn(v, "vvv")
            if (v.type == "0" && v.flag == "0") {
              if (v.image != null && v.image != "") {
                this.banner1Type = 0;
                this.banner1 = v.image.split(",");
                this.bannerUrl1 = v.url.split(",");
              } else {
                this.banner1Type = 1;
                this.banner1 = v.video;
                this.bannerUrl1 = "";
                this.banner1Video = v.videoUrl;
              }
            }
            if (v.type == "0" && v.flag == "1") {
              if (v.image != null && v.image != "") {
                this.banner2Type = 0;
                this.banner2 = v.image.split(",");
                this.bannerUrl2 = v.url.split(",");
                // console.warn(this.banner2, " this.banner2")
              } else {
                this.banner2Type = 1;
                this.banner2 = v.video;
                this.bannerUrl2 = "";
                this.banner2Video = v.videoUrl;
              }
            }
            if (v.type == "2" && v.flag == "0") {
              if (v.image != null && v.image != "") {
                this.banner3Type = 0;
                this.banner3 = v.image.split(",");
                this.bannerUrl3 = v.url;
              } else {
                this.banner3Type = 1;
                this.banner3 = v.video;
                this.bannerUrl3 = "";
                this.banner3Video = v.videoUrl;
              }
            }
            if (v.type == "1" && v.flag == "0") {
              if (v.image != null && v.image != "") {
                this.banner4Type = 0;
                this.banner4 = v.image.split(",");
                this.bannerUrl4 = v.url;
              } else {
                this.banner4Type = 1;
                this.banner4 = v.video;
                this.bannerUrl4 = "";
                this.banner4Video = v.videoUrl;
              }
            }
            if (v.type == "1" && v.flag == "1") {
              if (v.image != null && v.image != "") {
                this.banner5Type = 0;
                this.banner5 = v.image.split(",");
                this.bannerUrl5 = v.url;
              } else {
                this.banner5Type = 1;
                this.banner5 = v.video;
                this.bannerUrl5 = "";
                this.banner5Video = v.videoUrl;
              }

              if (v.imageTwo != null && v.imageTwo != "") {
                this.banner6Type = 0;
                this.banner6 = v.imageTwo.split(",");
                this.bannerUrl6 = v.urlTwo;
              } else {
                this.banner6Type = 1;
                this.banner6 = v.videoTwo;
                this.bannerUrl6 = "";
                this.banner6Video = v.videoUrl;
              }
            }
            if (v.type == "1" && v.flag == "2") {
              if (v.image != null && v.image != "") {
                this.banner7Type = 0;
                this.banner7 = v.image.split(",");
                this.bannerUrl7 = v.url;
              } else {
                this.banner7Type = 1;
                this.banner7 = v.video;
                this.bannerUrl7 = "";
                this.banner7Video = v.videoUrl;
              }

              if (v.imageTwo != null && v.imageTwo != "") {
                this.banner8Type = 0;
                this.banner8 = v.imageTwo.split(",");
                this.bannerUrl8 = v.urlTwo;
              } else {
                this.banner8Type = 1;
                this.banner8 = v.videoTwo;
                this.bannerUrl8 = "";
                this.banner8Video = v.videoUrl;
              }

              if (v.imageThree != null && v.imageThree != "") {
                this.banner9Type = 0;
                this.banner9 = v.imageThree.split(",");
                this.bannerUrl9 = v.urlThree;
              } else {
                this.banner9Type = 1;
                this.banner9 = v.videoThree;
                this.bannerUrl9 = "";
                this.banner9Video = v.videoUrl;
              }
            }

          })
        }


        this.imgLoad();
        window.addEventListener("resize", this.imgLoad, false);
      } catch (error) {
        this.$msg((error || {}).msg)
      }
    },


    GON() {
      this.$message({
        message: 'No access to the website',
        type: 'warning'
      });
    },
    GO() {
      localStorage.setItem('TWO_ONE_AGE', true);
      this.dialogVisible = false;
    },
    handleClose(done) {

    },
    topM() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;


      // let scrollToptimer = setInterval(function () {
      //   // console.log("定时循环回到顶部");
      //   var top = document.body.scrollTop || document.documentElement.scrollTop;
      //   var speed = top / 4;
      //   document.documentElement.scrollTop -= speed;
      //   if (top == 0) {
      //     clearInterval(scrollToptimer);
      //   }
      // }, 30);
    },
    kf() {
      window.open('https://b.163.com/home/qiyu/onlinekefu13723757593')
    },
    goCar() {
      this.$router.push(`/home/car`);
    },
    /** 去商品列表 */
    toGoodList(info, idx) {
      console.warn(info, "++++++++++++")
      // let openType;
      // switch (this.oneActive) {
      //   case "0":
      //   case "1":
      //     openType = this.oneActive;
      //     break;
      //   case "2":
      //     openType = "1";
      //     break;
      //   case "3":
      //     openType = "2";
      //     break;
      // }
      console.warn(this.oneActive, "this.oneActivethis.oneActivethis.oneActive")
      // this.$router.push(`/home/goodList?openType=${openType}&bid=${info.brandId}`);
      this.$router.push(`/home/BrandsLIst?ids=${info.brandId}&idx=${idx}`);
    },
    /** 列表分页改变 */
    goodListPageChange(page) {
      this.goodListpage = page;
      this.getgoodList();
    },
    /** 获取列表 */
    async getgoodList() {
      try {
        this.goodListLoading = true;
        var res = await this.$get('system/goods/list', {
          pageNum: this.goodListpage,
          pageSize: this.goodList_rows,
          brandId: "",
          type: 2,
        })
        this.goodList = this.goodListAttrFormat(res.rows || []);
        console.warn(this.goodList, "hot")
      } catch (error) {
      }
      this.goodListLoading = false;
    },
    /** 获取品牌列表 */
    async getBrandList() {
      try {
        const res = await this.$get('system/brand/list');
        this.brandListNews = res.rows || [];
        // this.goTab(this.List[0].brandId)
        console.warn(res, "查询品牌")
      } catch (error) {
      }
      // const apiType = this.oneActive;
      // this.$get("system/brand/list?type=" + this.oneActive).then(res => {
      //   if (apiType == this.oneActive) this.brandList = res.rows || [];
      // })
    },
    /** 加入购物车 */
    addCar(info = {}) {
      if (info.loading) return;
      info.loading = true;
      this.$post("system/cart", {
        "goodsId": info.goodsId, //商品id
        "number": 1, //数量
        "falvorId": info.firstFlavors.falvorId, //口味id
        "nicotineId": info.firstNicotine.nicotineId //尼古丁id
      }).then(res => {
        this.$msg((res || {}).msg || "succeed")
      }).catch(err => {
        this.$msg((err || {}).msg || "加入购物车fail")
      }).finally(_ => info.loading = false)
    },
    // banner被点击
    bannerClick(item = {}) {
      if (!item.url) return;
      window.open(item.url);
    },
    // 二级分类向左滑动
    offsetLeft() {
      const scroll = this.$refs.scroll;
      var left = this.towScrollLeft - 500;
      if (left < 0) left = 0;
      this.towScrollLeft = left;
      scroll.scrollTo({
        left,
        behavior: 'smooth'
      })
    },
    // 二级分类向右滑动
    offsetRight() {
      const scroll = this.$refs.scroll;
      var left = this.towScrollLeft + 500;
      if (left > scroll.scrollWidth) left = scroll.scrollWidth;
      this.towScrollLeft = left;
      scroll.scrollTo({
        left,
        behavior: 'smooth'
      })
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';

.pup {
  display: flex;
  align-items: center;
  flex-direction: column;
  // width: 716px;
  // height: 435px;
  background: #ffffff;
  border-radius: 8px;

  .topImg {
    width: 106px;
    height: 87px;
  }

  .t1 {
    margin-top: 32px;
    font-size: 40px;
    font-family: Poppins, Poppins-700;
    font-weight: 700;
    color: #000000;
  }

  .t2 {
    margin-top: 24px;
    font-size: 16px;
    font-family: Inter, Inter-500;
    font-weight: 500;
    color: #8fa2b2;
  }

  .btnV {
    width: 100%;
    margin-top: 64px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .btn1 {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 209px;
      height: 47px;
      background: #f624d5 linear-gradient(90deg, #f624d5, #3437f7 100%);
      border-radius: 8px;
      font-size: 16px;
      font-family: Inter, Inter-500;
      font-weight: 500;
      color: #ffffff;
    }

    .btn2 {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 190px;
      height: 47px;
      background: #12181d;
      border-radius: 8px;
      font-size: 16px;
      font-family: Inter, Inter-500;
      font-weight: 500;
      color: #ffffff;
    }
  }
}

// .top_gg img {
//   width: 100%;
// }


.img_line_box img {
  width: 100%;
}

.tuijian_box img {
  height: 100% !important;
  width: 100% !important;
}



::v-deep .el-dialog__header {
  padding: 0 0 !important;
}
</style>
